import { GlobalSearchBar } from '@akyga/shared-ui/GlobalSearchBar';

export default GlobalSearchBar;
